import React from "react";
import './Not.css'


function Notavailable() {
    return (
        <>
            <div className="notback">
                <h2 className="table">Temporarily Table Not Available.....</h2>
            </div>
        </>
    )



}
export default Notavailable;